export function showMessageAndOption(self, element) {
  element.show();
  if ($('.alert-danger').is(':visible')) {
    $('.alert-danger').text(self._object.required_text);
  } else {
    $('.question-text').after(
      '<div class="alert alert-danger">' + self._object.required_text + '</div>'
    );
  }
}
